import React from 'react';
import toolActions from '../../redux/futures/tools/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import Input from '../../components/Input';

import * as types from '../../redux/futures/tools/types';




class CreateProDNS extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            domain: '',
            typing: false,
            typingTimeout: 0,
            loading: false,
            loadingCheckCert: false,
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary",
            classApplyCheckCert: "ladiui button primary",
            mode: '',
            certInfo: {},
            isCreated: false
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
        this.initialState = _.cloneDeep(this.state);
        // this.defaultState = _.cloneDeep(this.state.user);
    }


    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {

            if (nextProps.action == types.CREATE_CERT) {
                this.setState({
                    loadingCheckCert: false,
                    classApplyCheckCert: this.state.classNormal
                });
                if (nextProps.status) {
                    window.LadiUI.toastr('success', '', nextProps.message);
                    this.setState({
                        certInfo: nextProps.certInfo
                    });
                } else {
                    window.LadiUI.toastr('error', '', nextProps.message);
                }

            }

            if (nextProps.action == types.CREATE_PRODNS) {
                this.setState({
                    loading: false,
                    classApply: this.state.classNormal
                });
                if (nextProps.status) {
                    window.LadiUI.toastr('success', '', nextProps.message);
                    // if (nextProps.result && nextProps.result.domainSsl) {
                    this.setState({
                        isCreated: true
                    })
                    // }
                    setTimeout(function () {
                        window.LadiUI.closeModalById('create-prodns');

                    }, 1000);

                } else {
                    window.LadiUI.toastr('error', '', nextProps.message);
                }
            }
        }
    }

    checkCert = () => {

        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            // console.log(ref);
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }
        const { domain } = this.state;
        const jsonData = {
            domain
        }
        this.props.createCert(jsonData);

        this.state.loadingCheckCert = true;
        this.state.classApplyCheckCert = this.state.classLoading;

    }

    submit = () => {
        const { domain, certInfo } = this.state;
        if (certInfo.Status != 'ISSUED' || !certInfo.Arn) {
            window.LadiUI.toastr('error', '', 'Tên miền chưa được khởi tạo SSL, vui lòng tạo các bản ghi CNAME để khởi tạo SSL');
            return;
        }
        const jsonData = {
            domain,
            certificate_arn: certInfo.Arn
        }
        this.props.createProDNS(jsonData);
        this.state.loading = true;
        this.state.classApply = this.state.classLoading;
    }


    onChangeInput = (event) => {

        this.setState({
            domain: event.target.value
        });
    }


    resetForm = (event) => {
        if (event && event.target && !event.target.hasAttribute("data-dismiss")) {
            return;
        }


        this.setState({
            ..._.cloneDeep(this.initialState)
        })

    }

    copyToClipboard = (user) => {
        // console.log(store.store_id);
        this.setState({
            copyiedUserID: user._id
        }, () => {
            this.textAreaRef.select();
            document.execCommand('copy');
            window.LadiUI.toastr('success', '', 'Đã copy vào clipboard');
        })

    };

    render() {
        const { domain, certInfo, isCreated } = this.state;
        console.log(certInfo);

        const title = 'Kiểm tra tên miền';

        return (
            <div ref={this.ref} id="create-prodns" className="ladiui-modal fade" tabIndex={-1} data-dismiss="create-prodns" style={{ zIndex: '21' }}>
                <div className="ladiui-modal-content" >
                    <div className="ladiui-modal-header"><button type="button" className="ladiui-close-modal" data-dismiss="create-prodns"><i className="ladi-icon icon-e-remove" data-dismiss="create-prodns" /></button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        {/* <form> */}
                        <div className="ladiui-tab-content">
                            <div className="ladiui form-group">
                                <label className="ladiui-label">Tên miền</label>
                                <Input
                                    ref={(ref) => this.inputsRef.add(ref)}
                                    name="domain"
                                    validationName="Domain"
                                    placeholder="Tên miền"
                                    value={domain}
                                    onChange={this.onChangeInput}
                                    validations={{ isRequired: true }}
                                />

                            </div>

                        </div>
                        <div className="ladiui-tab-content">
                            <h3>Kiểm tra SSL tên miền</h3>
                            <p>Bước 1: Kiểm tra SSL tên miền, nếu tên miền đã được khởi tạo SSL, vui lòng bấm tạo mới để tạo ProDNS</p>
                            <p>Bước 2: Nếu tên miền chưa được khởi tạo SSL, vui lòng tạo các bản ghi CNAME để khởi tạo SSL</p>
                        </div>
                        <div className="ladiui-tab-content">
                            <h3>Tạo ProDNS</h3>
                            <p>Bước 3: Đợi khoảng 5-10 phút để cấu hình hoàn tất, sau đó bạn có thể lấy cấu hình bản ghi DNS (ở màn hình danh sách tên miền) để cấu hình vào các nhà cung cấp Tên miền.</p>
                        </div>
                        {
                            isCreated &&
                            <div>
                                <p>Tên miền đã được tạo ProDNS, vui lòng đợi trong khoảng từ 5-10 phút để cấu hình hoàn tất, sau đó bạn có thể lấy cấu hình bản ghi DNS để cấu hình vào các nhà cung cấp Tên miền.</p>
                            </div>
                        }
                        {
                            certInfo && certInfo.Status == 'ISSUED' &&
                            <div >
                                <p>Tên miền đã được khởi tạo SSL, vui lòng bấm tạo mới để tạo ProDNS</p>
                                <p>SSL Issued:</p> {certInfo.NotAfter}
                                <br />
                                <p>SSL Expired:</p> {certInfo.NotBefore}
                                <br />
                            </div>
                        }
                        {
                            certInfo && certInfo.Status == 'PENDING_VALIDATION' &&
                            <div>
                                <b>Tên miền chưa được khởi tạo SSL, vui lòng tạo các bản ghi CNAME để khởi tạo:</b>
                                <br />
                                {certInfo.DNSValidations.map((record, index) => (
                                    <div key={index}>

                                        <b>CNAME</b>
                                        <br />
                                        <input readOnly
                                            type="text"
                                            className="ladiui input"
                                            ref={(textarea) => this.textAreaCnameRef = textarea} value={record.CNAME ? record.CNAME.slice(0, -1) : ''} />
                                        <br />
                                        <b>CNAME Value</b>
                                        <br />
                                        <input readOnly
                                            type="text"
                                            className="ladiui input"
                                            ref={(textarea) => this.textAreaCnameValueRef = textarea} value={record.CNAMEValue ? record.CNAMEValue.slice(0, -1) : ''} />
                                    </div>

                                ))
                                }
                            </div>
                        }


                    </div>

                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="create-prodns">
                            <i className="ladi-icon icon-e-remove" data-dismiss="create-prodns" />Đóng
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApplyCheckCert}
                            onClick={this.checkCert}
                            disabled={this.state.loadingCheckCert}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Check thông tin SSL
                        </button>

                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Tạo mới
                        </button>

                    </div>
                </div>
            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createProDNS: (data) => dispatch(toolActions.createProDNS(data)),
        createCert: (data) => dispatch(toolActions.createCert(data))
    }
}

const mapStateToProps = (state) => ({ ...state.tool });

export default connect(mapStateToProps, mapDispatchToProps)(CreateProDNS);